import { render, staticRenderFns } from "./CheckOK.vue?vue&type=template&id=23ef0fe8&"
import script from "./CheckOK.vue?vue&type=script&lang=js&"
export * from "./CheckOK.vue?vue&type=script&lang=js&"
import style0 from "./CheckOK.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports